<template>
    <div class="c-essence-wrap" v-if="essenceList && essenceList.length">
        <div class="section">
            <div class="header">
                <div class="title">附加精华课</div>
                <div class="more" @click="additionalVisible = true">查看更多</div>
            </div>
            <div class="content">
                <div class="item" v-for="(v,i) in essenceList.filter((v,i) => i < 4)" :key="i">
                    <div class="left">
                        <img :src="v.picture" alt="">
                    </div>
                    <div class="right">
                        <div class="name">{{ v.courseName }}</div>
                        <div class="brief">{{ v.courseIntroduce }}</div>
                        <div class="other">
                            <p class="price">¥{{ v.payConPrice }}</p>
                            <p class="like">{{ v.viewCount }}人学习</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <van-popup v-model="additionalVisible" position="bottom" class="additional-wrap">
            <div class="content-title">全部附加权益 <img @click="additionalVisible = false" class="close" src="@/assets/vipGoods/icon_gb.png" alt=""></div>
            <div class="content">
                <div class="item" v-for="(v,i) in essenceList" :key="i">
                    <div class="left">
                        <img :src="v.picture" alt="">
                    </div>
                    <div class="right">
                        <div class="name">{{ v.courseName }}</div>
                        <div class="brief">{{ v.courseIntroduce }}</div>
                        <div class="other">
                            <p class="price">¥{{ v.payConPrice }}</p>
                            <p class="like">{{ v.viewCount }}人学习</p>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
import { Popup } from 'vant'
export default {
    components: {
        [Popup.name]: Popup
    },
    props: ['essenceList'],
    data () {
        return {
            additionalVisible: false
        }
    }
}

</script>
<style scoped lang="scss">
.c-essence-wrap{
    margin: 7px 0 0 0;
    padding: 0 10px;
    .section{
        .header{
            display: flex;
            align-items: center;
            justify-content: space-between;
            .title{
                font-size: 18px;
                font-weight: 600;
                color: #000000;
            }
            .more{
                font-size: 13px;
                color: #666666;
                &::after{
                    content: ' ';
                    padding: 0 15px 0 0;
                    background: url("~@/assets/vipGoods/icon_jhkfy.png") no-repeat right/12px;
                }
            }
        }
        .content{
            padding: 10px 0;
            margin: 15px 0 0 0;
            box-sizing: border-box;
            width: 355px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 3px solid #FF5825;
            .item{
                position: relative;
                display: flex;
                padding: 15px;
                .left{
                    width: 155px;
                    height: 100px;
                }
                .left img{
                    border-radius: 5px;
                    height: 100%;
                    width: 100%;
                }
                .right{
                    line-height: 1;
                    flex: 1;
                    margin: 0 0 0 10px;
                }
                .right .name{
                    margin: 5px 0 0 0;
                    font-size: 15px;
                    font-weight: 600;
                    color: #333333;
                }
                .right .brief{
                    height: 36px;
                    margin: 10px 0 0 0;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    -webkit-line-clamp: 2;
                    font-size: 13px;
                    color: #999999;
                    line-height: 18px;
                }
                .other{
                    display: flex;
                    align-items: center;
                    margin: 16px 0 0 0;
                }
                .other .price{
                    font-size: 18px;
                    font-weight: 600;
                    color: #FF5050;
                }
                .other .price::first-letter{
                    font-size: 13px;
                }
                .other .like{
                    line-height: 16px;
                    margin:  0 0 0 16px;
                    padding: 0 0 0 21px;
                    font-size: 13px;
                    color: #FF5050;
                    background: url("~@/assets/vipGoods/icon_xx.png") no-repeat left -1px/16px;

                }
            }
            .item+.item::before{
                position: absolute;
                top: 1px;
                content: ' ';
                height: 1px;
                width: 325px;
                background: #eeeeee;
            }
        }
    }

}
.additional-wrap{
    width: 375px;
    height: 590px;
    background: #FFFFFF;
    overflow: hidden;
    box-sizing: border-box;
    border-radius: 10px 10px 0 0;
    .content-title{
        line-height: 1;
        margin: 15px 0 0 0;
        position: relative;
        text-align: center;
        font-size: 18px;
        font-weight: 600;
        color: #000000;
        .close{
            position: absolute;
            right: 15px;
            top: 50%;
            transform: translateY(-50%);
            width: 18px;
        }
    }
    .content{
        -webkit-overflow-scrolling: touch;
        margin: 5px 0 0 0;
        height: 530px;
        overflow: auto;
        .item{
            position: relative;
            display: flex;
            padding: 15px;
            .left{
                width: 155px;
                height: 100px;
            }
            .left img{
                border-radius: 5px;
                height: 100%;
                width: 100%;
            }
            .right{
                line-height: 1;
                flex: 1;
                margin: 0 0 0 10px;
            }
            .right .name{
                margin: 5px 0 0 0;
                font-size: 15px;
                font-weight: 600;
                color: #333333;
            }
            .right .brief{
                height: 36px;
                margin: 10px 0 0 0;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
                -webkit-line-clamp: 2;
                font-size: 13px;
                color: #999999;
                line-height: 18px;
            }
            .other{
                display: flex;
                align-items: center;
                margin: 16px 0 0 0;
            }
            .other .price{
                font-size: 18px;
                font-weight: 600;
                color: #FF5050;
            }
            .other .price::first-letter{
                font-size: 13px;
            }
            .other .like{
                line-height: 16px;
                margin:  0 0 0 16px;
                padding: 0 0 0 21px;
                font-size: 13px;
                color: #FF5050;
                background: url("~@/assets/vipGoods/icon_xx.png") no-repeat left -1px/16px;

            }
        }
        .item+.item::before{
            position: absolute;
            top: 1px;
            content: ' ';
            height: 1px;
            width: 345px;
            background: #eeeeee;
        }
    }
}

</style>
